import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=07c3e19e&scoped=true&"
import script from "./LeftSidebar.vue?vue&type=script&lang=js&"
export * from "./LeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LeftSidebar.vue?vue&type=style&index=0&id=07c3e19e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c3e19e",
  null
  
)

export default component.exports